<template>
  <div>
    <title-edit header="Menu" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Branch* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option :items="optionBranch" @update="updateBranch" :model="form.branch_id" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Service* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option :items="optionService" @update="updateService" :model="form.service_id" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Menu TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.title_th" @update="updateMenuTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Menu EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.title_en" @update="updateMenuEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.description_th" @update="updateDescriptionTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.description_en" @update="updateDescriptionEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Slug Url :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.slug_url" @update="updateSlugUrl" />
      </v-col>
    </div>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" align="center" justify="center">
        <submit-button @click.native="openSubMenu(null)" label="+ Sub menu" />
      </v-col>
    </v-row>
    <div class="row justify-center d-flex">
      <v-col cols="12">
        <v-simple-table class="branch-data">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center" v-for="header in headers" :key="header.id">
                  {{ header.text }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(subMenu, index) in subMenuTable" :key="subMenu.id">
                <td align="center">{{ ++index }}</td>
                <td>{{ subMenu.service ? subMenu.service.title_en : "" }}</td>
                <td>{{ subMenu.title_th }}</td>
                <td>{{ subMenu.title_en }}</td>
                <td>{{ subMenu.slug_url }}</td>
                <td width="150px" align="center">
                  <a @click="openSubMenu(subMenu.sub_menu_id)">
                    <v-icon
                      class="fas fa-pencil-alt"
                      style="color: #2E8037;font-size: 20px"
                    ></v-icon> </a
                  >&nbsp;
                  <a @click="deleteSubMenu(subMenu.id,index-1)">
                    <v-icon class="fas fa-trash" style="color: #2E8037;font-size: 20px"></v-icon>
                  </a>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-col sm="2"></v-col>
    </div>
    <line-hr />
    <div class="row text-right">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteMenu" />
<!--      <preview-button />-->
      <save-button @click.native="saveMenu" />
    </div>
    <v-dialog v-model="dialog" scrollable width="600px">
      <create-sub-menu-modal :services="optionService" @update="saveSubMenuDetails" />
    </v-dialog>
  </div>
</template>

<script>
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import SelectOption from "../../../components/Input/selectOption";
import InputTextField from "../../../components/Input/InputTextField";
import InputEditor from "../../../components/Input/InputEditor";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import { mapState } from "vuex";
import InputImageUpload from "../../../components/Input/InputImageUpload";
import AutoComplete from "../../../components/Input/AutoComplete";
import SubmitButton from "../../../components/Button/SubmitButton";
import CreateSubMenuModal from "./CreateSubMenuModal";
import IconPencil from "../../../components/Icon/icon-pencil";
export default {
  name: "MenuEdit",
  components: {
    IconPencil,
    CreateSubMenuModal,
    SubmitButton,
    AutoComplete,
    InputImageUpload,
    SaveButton,
    PreviewButton,
    DeleteButton,
    InputEditor,
    InputTextField,
    SelectOption,
    LineHr,
    TitleEdit
  },
  data() {
    return {
      optionBranch: [],
      optionService: [],
      dialog: false,
      subMenuTable: [],
      headers: [
        { id: 1, text: "No." },
        { id: 2, text: "Service" },
        { id: 3, text: "Name TH" },
        { id: 4, text: "Name EN" },
        { id: 5, text: "Slug Url" },
        { id: 6, text: "Edit" }
      ]
    };
  },
  computed: {
    ...mapState({
      form: state => {
        return state.Menu.form;
      }
    })
  },
  created() {
    this.getBranchData();
    this.getServiceByBranch();
    if (this.form.menu_id) {
      this.getSubMenuTable(this.form.menu_id);
    }
  },
  methods: {
    getSubMenuTable(id) {
      this.$store.dispatch("SubMenu/getSubMenuFromMenuId", id).then(res => {
        this.subMenuTable = res;
      });
    },
    getServiceByBranch() {
      let branch_id = this.form.branch_id;
      if (branch_id) {
        this.$store.dispatch("Services/getServiceByBranch", branch_id).then(res => {
          if (res.response_code == 200) {
            this.optionService = [
              { text: "Select", value: "" },
              ...res.result.map(type => ({
                value: type.service_id,
                text: type.title_en + " (" + type.title_en + ")"
              }))
            ];
          }
        });
      }
    },
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    goToMenuTable() {
      this.$router.push("/menu/menu");
    },
    openSubMenu(id) {
      if (id) {
        this.$store.dispatch("SubMenu/showSubMenu", id).then(res => {
          if (res.response_code == 200) {
            this.$store.dispatch("SubMenu/setFormSubMenu", res.result);
          } else {
            alert(res.response_msg);
          }
        });
      } else {
        this.$store.dispatch("SubMenu/clearFormData");
      }
      this.dialog = true;
    },
    deleteSubMenu(id,index){
      if(id){
        this.$store.dispatch("SubMenu/deleteSubMenu",id).then(res=>{
          alert(res.response_msg);
          if (res.response_code == 200){
            this.removeSubMenu(index);
          }
        }).catch(()=>{
          alert('cannot delete sub menu');
        })
      }else{
        this.removeSubMenu(index);
      }
    },
    removeSubMenu(index){
      this.subMenuTable = this.subMenuTable.filter(
        (detail, itemIndex) => index !== itemIndex
      );
    },
    validateSave() {
      if (!this.form.branch_id) {
        alert("please select Branch !");
        return false;
      } else if (!this.form.service_id) {
        alert("please insert Service !");
        return false;
      } else if (!this.form.title_th) {
        alert("please insert Menu TH !");
        return false;
      } else if (!this.form.title_en) {
        alert("please insert Menu EN !");
        return false;
      } else if (!this.form.description_th) {
        alert("please insert Description TH !");
        return false;
      } else if (!this.form.description_en) {
        alert("please insert Description EN !");
        return false;
      } else {
        return true;
      }
    },
    saveMenu() {
      if (this.validateSave) {
        this.form.sub_menu = this.subMenuTable;
        this.$store
          .dispatch("Menu/saveMenu", {
            id: this.form.menu_id,
            data: this.form
          })
          .then(res => {
            alert(res.response_msg);
            if (res.response_code == 200) {
              this.goToMenuTable();
            }
          })
          .catch(() => {
            alert("cannot save menu data");
          });
      }
    },
    saveSubMenuDetails(val) {
      this.dialog = false;
      if (val) {
        if(val){
          this.subMenuTable.push(val);
        }
      }
    },
    deleteMenu() {
      this.$store
        .dispatch("Menu/deleteMenu", this.form.menu_id)
        .then(res => {
          alert(res.response_msg);
          if (res.response_code == 200) {
            this.goToMenuTable();
          }
        })
        .catch(() => {
          alert("cannot delete menu data");
        });
    },
    updateBranch(val) {
      this.form.branch_id = val;
      this.getServiceByBranch();
    },
    updateService(val) {
      this.form.service_id = val;
    },
    updateMenuTH(val) {
      this.form.title_th = val;
    },
    updateMenuEN(val) {
      this.form.title_en = val;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateSlugUrl(val) {
      this.form.slug_url = val;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/variables.scss";
@import "../../../assets/css/table.css";
.branch-data {
  background-color: transparent;
  margin: 20px;
}
</style>
